import { render, staticRenderFns } from "./Composer.vue?vue&type=template&id=5e12a3fc&scoped=true&"
import script from "./Composer.vue?vue&type=script&lang=js&"
export * from "./Composer.vue?vue&type=script&lang=js&"
import style0 from "./Composer.vue?vue&type=style&index=0&id=5e12a3fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e12a3fc",
  null
  
)

export default component.exports